import type { z } from 'zod'
import { projectDataApi } from './projectDataApi'
import { MonitoringStatusSchema, MonitoringSessionsSchema } from '../schemas/sessionMonitoring'

const api = projectDataApi.injectEndpoints({
  endpoints: builder => ({
    getMonitoringStatus: builder.query<z.infer<typeof MonitoringStatusSchema>, string>({
      query: projectId => ({ url: '/api/project-session-monitoring', params: { project_id: projectId } }),
      transformResponse: (response: unknown) => MonitoringStatusSchema.parse(response),
      providesTags: (_result, _error, projectId) => [{ type: 'ProjectUserSessions', id: projectId }],
    }),
    getMonitoringSessions: builder.query<z.infer<typeof MonitoringSessionsSchema>, { projectId: string; runId: string; page: number }>({
      query: ({ projectId, runId, page }) => ({ url: '/api/project-session-monitoring', params: { project_id: projectId, run_id: runId, page } }),
      transformResponse: (response: unknown) => MonitoringSessionsSchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }],
    }),
  }),
})
export const { useGetMonitoringStatusQuery, useGetMonitoringSessionsQuery } = api
